import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface BuyCounter extends Doc {
  _id: string;
  cardId: number;
  num: number;
  stamp: number;
}

type Model = BuyCounter;
type Refs = References<Model>;

export const BuyCounters = new Mongo.Collection<BuyCounter>('buyCounters');

export const listBuyCounters = DeclareMethod<ListMethodArg<BuyCounter>, ListMethodResponse<BuyCounter, Refs>>('listBuyCounters');
export const getBuyCounter = DeclareMethod<string, GetMethodResponse<BuyCounter, Refs>>('getBuyCounter');
export const createBuyCounter = DeclareMethod<Partial<BuyCounter>, string>('createBuyCounter');
export const updateBuyCounter = DeclareMethod<Partial<BuyCounter>, string>('updateBuyCounter');
export const deleteBuyCounter = DeclareMethod<string, undefined>('deleteBuyCounter');

export const modelClass: ModelClass<Model, Refs> = {
  collection: BuyCounters,
  editableFields: ['cardId', 'num', 'stamp'],
  listMethod: listBuyCounters,
  getMethod: getBuyCounter,
  createMethod: createBuyCounter,
  updateMethod: updateBuyCounter,
  deleteMethod: deleteBuyCounter,
  pathPrefix: '/buy-counters',
  modelName: 'Buy Counter',
  pluralName: 'Buy Counters',
};
